// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var _a;
import { ESyncChangeCategory } from "./types";
export var CATEGORY_COLORS = (_a = {},
    _a[ESyncChangeCategory.VOTED_INTERNET] = "info",
    _a[ESyncChangeCategory.VOTED_OTHER_CHANNEL] = "warning",
    _a[ESyncChangeCategory.DISABLED_DELETE_CALL] = "warning",
    _a[ESyncChangeCategory.DELETION_REVERTED] = "info",
    _a[ESyncChangeCategory.PROFILE_UPDATE] = "default",
    _a[ESyncChangeCategory.VOTER_ADDED] = "success",
    _a[ESyncChangeCategory.REENABLED] = "success",
    _a[ESyncChangeCategory.VOTED_UNMARKED] = "warning",
    _a[ESyncChangeCategory.ROW_FAILURE] = "error",
    _a);
// Acceptance criteria: the apply-patch confirmation dialog highlights the
// categories that touch voted status or disable voters.
export var HIGHLIGHTED_CATEGORIES = new Set([
    ESyncChangeCategory.VOTED_INTERNET,
    ESyncChangeCategory.VOTED_OTHER_CHANNEL,
    ESyncChangeCategory.VOTED_UNMARKED,
    ESyncChangeCategory.DISABLED_DELETE_CALL,
]);
